import _ from "lodash";
import moment from "moment";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { DatePicker, Table, Select, TableColumnsType } from "antd";
import { ApprovalLineType, ApprovalStatusType, ExpensePageType, FINANCIAL_EDIT_PERMISSION, FINANCIAL_TEAM_CODE } from "../../../../constans";
import Button from "../../../Button";
import { IApprovalLine, IEmployeeValue, IGetExpense, IGetExpenseLine } from "../../../../models/financials.model";
import useAxios from "../../../../hooks/useAxios";
import { deleteExpense, getApprovalLine, getExpense, updateExpenseAmount } from "../../../../api/financials.api";
import { useEffect, useRef, useState } from "react";
import { getCommonCodeLabel } from "../../../../lib/store";
import { RootState } from "../../../../store/rootReducer";
import { IResponse } from "../../../../models/common.api.model";
import ConfirmModal from "../../../modals/ConfirmModal";
import { ISubcode } from "../../../../models/codes.model";
import useNotification from "../../../../hooks/useNotification";
import { ITreeCode, ITreeSubcode } from "../../../../models/treeCodes.model";
import { CgCloseR } from "react-icons/cg";
import FileUpload from "../../../FileUpload";

interface IProps {
    expenseCode: number,
    commonCode: string,
    setPageType: (param: ExpensePageType) => void;
    getExpenseList: (listType: 'A' | 'P') => void;
}

const ExpenseEditAmount = ({expenseCode, commonCode, setPageType, getExpenseList} : IProps) => {
    const { t, i18n } = useTranslation();
    const { auth } = useSelector((state: RootState) => state.auth);
    const { infoNotification, successNotification } = useNotification();

    const { data: expenseDetail, isLoading, error, execute: executeDetail } = useAxios<IGetExpense>();
    const { data: expenseLine, isLoading : loading3, error : lineError, execute: executeLine } = useAxios<IGetExpenseLine>();
    const { data: editResult, isLoading : loading4 , error : editError, execute: executeSave } = useAxios<IResponse<Number>>();

    const [confirmEditVisible, setConfirmEditVisible] = useState(false);
    //결재라인
    const [selectedApprovalList, setSelectedApprovalList] = useState<Map<string, IEmployeeValue>>(new Map<string, IEmployeeValue>());
    const [approvalListData, setApprovalListData] = useState<any>([]);
    //수신참조
    const [selectedCCList, setSelectedCCList] = useState<Map<string, IEmployeeValue>>(new Map<string, IEmployeeValue>());
    const [ccListData, setCCListData] = useState<any>();

    const { commonCodes } = useSelector((state: RootState) => state.commonCode);
    // FA0007 = 결재라인 기본값
    const FA0007 = commonCodes.find(item => item.commonCode === 'FA0007')?.detailCode;
    // FA0008 = 수신참조 기본값
    const FA0008 = commonCodes.find(item => item.commonCode === 'FA0008')?.detailCode;
    
    const { treeCodes } = useSelector((state: RootState) => state.treeCodeData);
    // FA0001 = 지출 코드
    const FA0001 = treeCodes.filter(item => (item.commonCode === commonCode && item.treeLevel === 1));

    //계정
    const [account1, setAccount1] = useState<string>();
    const [account2, setAccount2] = useState<string>();
    const [account3, setAccount3] = useState<string>();
    const [account2List, setAccount2List] = useState<ITreeSubcode[]>();
    const [account3List, setAccount3List] = useState<ITreeSubcode[]>();
    const [expenseDate, setExpenseDate] = useState('');   //지출일
    const [title, setTitle] = useState('');   //제목
    const [summary, setSummary] = useState('');   //적요
    const [amount, setAmount] = useState(0);    //금액
    const [note, setNote] = useState('');   //비고
    const dateArea = useRef<any>();

    // 신규 첨부파일
    const [files, setFiles] = useState<any>([null]);
    // 수정 시 기존 첨부파일
    const [fileinfo, setFileinfo] = useState<any>([null]);
    
    useEffect(() => {
        getExpenseDetail();
        getExpenseLine();
    }, [expenseCode]);

    useEffect(() => {
        const appFinal : Map<string, IEmployeeValue> = new Map<string, IEmployeeValue>();
        const ccFinal : Map<string, IEmployeeValue> = new Map<string, IEmployeeValue>();

        if(expenseLine?.data) {
            expenseLine?.data.forEach((item) => {
                const memberCode = item.memberCode;
                const campusName = item.campusName
                const memberName = item.memberName + '(' + item.memberEngName + ')';
                if(item.lineType === ApprovalLineType.APPROVAL_LINE) {
                    let tempGroupName = getDefualtGroupName(FA0007, memberCode, campusName);
                    appFinal.set(memberCode, {campusCode:item.campusCode, campusName:tempGroupName, memberName:memberName});
                } else if(item.lineType === ApprovalLineType.CC_LINE) {
                    let tempGroupName = getDefualtGroupName(FA0008, memberCode, campusName);
                    ccFinal.set(memberCode, {campusCode:item.campusCode, campusName:tempGroupName, memberName:memberName});
                }
            });
        }

        setSelectedApprovalList(appFinal);
        setSelectedCCList(ccFinal);
    },[expenseLine]);

    useEffect(() => {
        let tempAppList : any = [];
        
        let orderSeq = 1;
        selectedApprovalList.forEach((value, key) => {
            tempAppList.push({memberCode:key, orderSeq:orderSeq, campusName:value.campusName, memberName:value.memberName})
            orderSeq++;
        });
        
        setApprovalListData(tempAppList);
    },[selectedApprovalList]);

    useEffect(() => {
        let tempAppList : any = [];
        
        let orderSeq = 1;
        selectedCCList.forEach((value, key) => {
            tempAppList.push({memberCode:key, orderSeq:orderSeq, campusName:value.campusName, memberName:value.memberName})
            orderSeq++;
        });
        
        setCCListData(tempAppList);
    },[selectedCCList]);

    useEffect(() => {
        if(editResult) {
            if(editResult.result === "success") {
                successNotification(t('common.message.save1'));

                getExpenseList('A');
                setPageType(ExpensePageType.VIEW);
            }
        }
    }, [editResult]);

    useEffect(() => {
        if(expenseDetail) {
            if(expenseDetail.result === "success") {
                setAccount1(expenseDetail.data.firstExpenseAccCode);
                setAccount2(expenseDetail.data.secondExpenseAccCode);
                setAccount3(expenseDetail.data.thirdExpenseAccCode);
                setAccount2List(treeCodes.filter(item => (item.commonCode === commonCode && item.treeLevel === 2 && item.parentDetailCode === Number(expenseDetail.data.firstExpenseAccCode) )))
                setAccount3List(treeCodes.filter(item => (item.commonCode === commonCode && item.treeLevel === 3 && item.parentDetailCode === Number(expenseDetail.data.secondExpenseAccCode) )))
                setExpenseDate(expenseDetail.data.expenseDate);
                setTitle(expenseDetail.data.title);
                setSummary(expenseDetail.data.summary);
                setAmount(expenseDetail?.data?.amount);
                setNote(expenseDetail.data.note);

                setFileinfo(_.cloneDeep(expenseDetail.data.files));
            }
        }
    }, [expenseDetail])

    const getExpenseDetail = () => {
        executeDetail(getExpense(expenseCode, commonCode));
    }

    const getExpenseLine = () => {
        executeLine(getApprovalLine(expenseCode));
    }

    //기본 참조,결재자 그룹명(직책) 변경
    const getDefualtGroupName = (lineList : ISubcode[] | undefined, memberCode : string, groupName : string) => {
        let tempGroupName = groupName;
        if(lineList && lineList.length > 0) {
            lineList.map((item) => {
                if(item.detailCode === memberCode) {
                    if(item.korName.indexOf('|') > -1 &&  item.engName.indexOf('|') > -1) {
                        tempGroupName = item.korName.split('|')[1];
                    }
                }
                return item;
            });
        }
        return tempGroupName;
    }

    const firstAccountChange = (value : any) => {
        setAccount1(value);
        if(value) {
            setAccount2List(treeCodes.filter(item => (item.commonCode === commonCode && item.treeLevel === 2 && item.parentDetailCode === Number(value) )))
            setAccount3List(undefined);
            setAccount2(undefined);
            setAccount3(undefined);
        }
    }

    const secondAccountChange = (value : any) => {
        setAccount2(value);
        if(value) {
            setAccount3(undefined);
            setAccount3List(treeCodes.filter(item => (item.commonCode === commonCode && item.treeLevel === 3 && item.parentDetailCode === Number(value) )));
        }
    }

    const onSetFile = (index: number, file: any) => {
        const _files = [...files];
        _files[index] = file;
        setFiles(_files);
    }
    
    const onAddFile = () => {
        const _files = [...files];
        _files.push(null);
        setFiles(_files);
    }
    
    const onDeleteFile = (index: number) => {
        const _files = [...files];
        _files.splice(index, 1);
        setFiles(_files);
    }

    const onDeleteAttachedFile = (index: number) => {
        const _fileinfo = [...fileinfo];
        _fileinfo[index].originalName = null;
        setFileinfo(_fileinfo);
    }

    const onSaveButton = () => {
        if(!account3) {
            return infoNotification(t('payment.income.msg2'));
        }

        if(!expenseDate) {            
            return infoNotification(t('payment.expense.msg1'));
        }
        
        if(!title) {            
            return infoNotification(t('payment.expense.msg2'));
        }

        if(!amount) {            
            return infoNotification(t('payment.income.msg5'));
        }

        //파라미터 셋팅(form)
        const form = new FormData();
        form.append('expenseAccCode', account3);        
        form.append('expenseDate', expenseDate);
        form.append('title', title);
        form.append('summary', summary);
        form.append('amount', amount.toString());
        form.append('note', note);
        
        // 파일 처리
        if (expenseDetail?.data?.attachFileCode) {
            form.append('attachFileCode', expenseDetail?.data?.attachFileCode);
        }

        if (fileinfo) {
            // 기존 첨부파일 있음
            let hasNewFiles = false;
            files.forEach((item: any) => {
            if (item) hasNewFiles = true;
            });

            let isAllDeleted = true;
            let hasDeleted = false;
            fileinfo.forEach((item: any) => {
            if (item.originalName) {
                isAllDeleted = false;
            } else {
                hasDeleted = true;
                form.append('deleteFiles', item.fileSeq);
            }
            });

            if (hasNewFiles) form.append('fileStatus', 'update');
            else if (isAllDeleted) form.append('fileStatus', 'delete');
            else if (hasDeleted) form.append('fileStatus', 'update');
            else form.append('fileStatus', 'keep');
        } else {
            // 기존 첨부파일 없음
            if (files.length > 0 && files[0] !== null) {
            // 추가 첨부파일 있음
            form.append('fileStatus', 'create');
            } else {
            // 추가 첨부파일 없음
            form.append('fileStatus', 'keep');
            }
        }

        if (files.length > 0) {
            files.forEach((item: any) => {
                if (item !== null) form.append('newFiles', item);
            });
        }

        executeSave(updateExpenseAmount(expenseCode, form));
    }

    const appLinecolumns: TableColumnsType<IApprovalLine> = [
        {
            title: t('system.menu.column1'),
            dataIndex: 'orderSeq',
            key: 'orderSeq',
            align: 'center',
        },
        {
            title: t('campus.staff.column38'),
            dataIndex: 'campusName',
            key: 'campusName',
            align: 'center',
        },
        {
            title: t('class.class.column74'),
            dataIndex: 'memberName',
            key: 'memberName',
            align: 'center',
        },
    ];

    const appCCLinecolumns: TableColumnsType<IApprovalLine> = [
        {
            title: t('campus.staff.column38'),
            dataIndex: 'campusName',
            key: 'campusName',
            align: 'center',
        },
        {
            title: t('class.class.column74'),
            dataIndex: 'memberName',
            key: 'memberName',
            align: 'center',
        },
    ];

    return(
        <>
            {/*
            <div className="comm-bx__between">  
                <h3 className='sub-title'>{t('payment.income.title3')}</h3>
            </div>
            */}
            <div className="w-100 flex">
                <div className="w-50">
                    <div className="comm-bx__space"> 
                        <div><h3 className="sub-title">{t('payment.expense.title1')}</h3></div>
                    </div>
                    <div className="comm-table__area">
                        <Table 
                            className='approvalLineTable'
                            columns={appLinecolumns}
                            dataSource={approvalListData}
                            rowKey={'memberCode'}
                            pagination={{
                                current: 1,
                                pageSize: 999999999,
                            }}
                        />
                    </div>
                </div>
                <div className="w-50 ml-2">
                    <div className="comm-bx__space"> 
                        <div><h3 className="sub-title">{t('payment.expense.title2')}</h3></div>
                    </div>
                    <div className="comm-table__area">
                        <Table 
                            columns={appCCLinecolumns}
                            dataSource={ccListData}
                            rowKey={'memberCode'}
                            pagination={{
                                current: 1,
                                pageSize: 999999999,
                            }}
                        />
                    </div>
                </div>
            </div>
            <div className="comm-bx__between">  
                <h3 className='sub-title'>{t('payment.expense.title4')}</h3>
            </div>
            <div className="comm-table__area rowType">
                <table>
                    <colgroup>
                        <col width="15%" />
                        <col width="85%" />
                    </colgroup>
                    <tbody>
                        <tr>
                            <th>{t('system.treecode.account1')}</th>
                            <td>
                                {/* i18n.language === 'ko' ? expenseDetail?.data?.firstExpenseAccName : expenseDetail?.data?.firstExpenseAccEngName */}
                                <Select
                                    placeholder={t('payment.income.search2') + ' ' + t('campus.staff.placeholder2')}
                                    className="w-240p"
                                    value={account1}
                                    onChange={(value)=>{
                                        firstAccountChange(value);
                                    }}
                                >
                                    {
                                        FA0001?.map((item : ITreeCode)=>{
                                            return(
                                                <Select.Option
                                                    key={item.detailCode.toString()}
                                                    value={item.detailCode.toString()}
                                                >
                                                    {i18n.language === 'ko' ? item.korName : item.engName}
                                                </Select.Option>
                                            );
                                        })
                                    }
                                </Select>
                            </td>
                        </tr>
                        <tr>
                            <th>{t('system.treecode.account2')}</th>
                            <td>
                                {/* i18n.language === 'ko' ? expenseDetail?.data?.secondExpenseAccName : expenseDetail?.data?.secondExpenseAccEngName */}
                                <Select
                                    placeholder={t('payment.income.search2') + ' ' + t('campus.staff.placeholder2')}
                                    className="w-240p"
                                    value={account2}
                                    onChange={(value)=>{
                                        secondAccountChange(value);
                                    }}
                                >
                                    {
                                        account2List?.map((item : ITreeCode)=>{
                                            return(
                                                <Select.Option
                                                    key={item.detailCode.toString()}
                                                    value={item.detailCode.toString()}
                                                >
                                                    {i18n.language === 'ko' ? item.korName : item.engName}
                                                </Select.Option>
                                            );
                                        })
                                    }
                                </Select>
                            </td>
                        </tr>
                        <tr>
                            <th>{t('system.treecode.account3')}</th>
                            <td>
                                {/* i18n.language === 'ko' ? expenseDetail?.data?.thirdExpenseAccName : expenseDetail?.data?.thirdExpenseAccEngName */} 
                                <Select
                                    placeholder={t('payment.income.search2') + ' ' + t('campus.staff.placeholder2')}
                                    className="w-240p"
                                    value={account3}
                                    onChange={(value)=>{
                                        setAccount3(value);
                                    }}
                                >
                                    {
                                        account3List?.map((item : ITreeCode)=>{
                                            return(
                                                <Select.Option
                                                    key={item.detailCode.toString()}
                                                    value={item.detailCode.toString()}
                                                >
                                                    {i18n.language === 'ko' ? item.korName : item.engName}
                                                </Select.Option>
                                            );
                                        })
                                    }
                                </Select>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div ref={dateArea} ></div>
            <div className="comm-table__area rowType">
                <table>
                    <colgroup>
                        <col width="15%" />
                        <col width="35%" />
                        <col width="15%" />
                        <col width="35%" />
                    </colgroup>
                    <tbody>
                        <tr>
                            <th>{t('student.student.62')}</th>
                            <td>{moment(expenseDetail?.data?.registDate).format("YYYY-MM-DD")}</td>
                            <th>{t('payment.expense.column1')}</th>
                            <td>
                                {/* moment(expenseDetail?.data?.expenseDate).format("YYYY-MM-DD") */}
                                <div className="date-picker__area">
                                    <DatePicker
                                        value={expenseDate ? moment(expenseDate) : undefined}
                                        onChange={e => {
                                            if (e === null) setExpenseDate('');
                                            else setExpenseDate(moment(e).format('YYYYMMDD'))
                                        }}
                                        format={['YYYY-MM-DD', 'YYYYMMDD']}
                                        getPopupContainer={() => {
                                            return dateArea.current as HTMLElement;
                                        }}
                                    />
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <th>{'* ' + t('common.column.title')}</th>
                            <td colSpan={3}>
                                <div className="w-100">
                                    {/* expenseDetail?.data?.title */}
                                    <input
                                        type="text"
                                        className="form-control input-text"
                                        value={title}
                                        onChange={e => setTitle(e.target.value)}
                                    />
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <th>{'* ' + t('payment.expense.label6')}</th>
                            <td colSpan={3}>
                                <textarea
                                    className="w-100"
                                    rows={5}
                                    /*value={expenseDetail?.data?.summary}*/
                                    value={summary}
                                    onChange={(e) => setSummary(e.target.value)}
                                    maxLength={1500}
                                />
                            </td>
                        </tr>
                        <tr>
                            <th>{t('payment.expense.column4')}</th>
                            <td>
                                {getCommonCodeLabel('FA0002', expenseDetail?.data?.expenseMtd, i18n.language)}
                            </td>
                            <th>{t('payment.expense.label5')}</th>
                            <td>
                                {getCommonCodeLabel('FA0003', expenseDetail?.data?.expenseYn, i18n.language)}
                            </td>
                        </tr>
                        <tr>
                            <th>{t('payment.income.column3')}</th>
                            <td>
                                {getCommonCodeLabel('FB0004', expenseDetail?.data?.currency, i18n.language)}
                            </td>
                            <th>{t('student.student.column97')}</th>
                            <td>
                                <div className="flex" style={{alignItems:'center', gap:'5px'}}>
                                    <input
                                        type="number"
                                        className="form-control input-text text-right w-160p"
                                        value={amount.toString()}
                                        onChange={e => {
                                            if(Number(e.target.value) < 0) {
                                                return false;
                                            }
                                            setAmount(Number(e.target.value))
                                        }}
                                    />
                                    <b>{t('campus.setting.text2')}</b>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <th>{t('payment.expense.column5')}</th>
                            <td colSpan={3}>
                                {expenseDetail?.data?.clientName}
                            </td>
                        </tr>
                        <tr>
                            <th>{t('payment.expense.column6')}</th>
                            <td>
                                {expenseDetail?.data?.clientDepositor}
                            </td>
                            <th>{t('homepage.member.20')}</th>
                            <td>
                                {expenseDetail?.data?.clientTelNo}
                            </td>
                        </tr>
                        <tr>
                            <th>{t('campus.shuttle.column12')}</th>
                            <td>
                                {getCommonCodeLabel('SY0007', expenseDetail?.data?.clientBankCode, i18n.language)}
                            </td>
                            <th>{t('campus.shuttle.column13')}</th>
                            <td>
                                {expenseDetail?.data?.clientAccNo}
                            </td>
                        </tr>
                        <tr>
                            <th>{t('payment.expense.label2')}</th>
                            <td>
                                {getCommonCodeLabel('FA0004', expenseDetail?.data?.proofType, i18n.language)}
                            </td>
                            <th>{t('payment.expense.label3')}</th>
                            <td>
                                {moment(expenseDetail?.data?.proofDate).format("YYYY-MM-DD")}
                            </td>
                        </tr>
                        {
                            expenseDetail?.data && fileinfo
                            ? (
                                <tr>
                                    <th>{t('archive.learn.column5')}</th>
                                    <td colSpan={3}>
                                        {
                                        fileinfo.map((item: any, index: number) => {
                                            const result = item?.originalName
                                            ? (
                                                <div key={index}>
                                                <a
                                                    className="download-link"
                                                    href={`${item.fileLocation}`}
                                                    download={item.originalName}
                                                >
                                                    {item.originalName}
                                                </a>
                                                <span
                                                    className="ml-1 pointer"
                                                    onClick={() => onDeleteAttachedFile(index)}
                                                >
                                                    <CgCloseR />
                                                </span>
                                                </div>
                                            )
                                            : null;
                                            return result;
                                        })
                                        }
                                    </td>
                                </tr>
                                )
                            : null
                        }
                        <tr>
                            <th>{expenseDetail?.data && fileinfo ? t('archive.learn.column6') : t('common.column.file')}</th>
                            <td colSpan={3}>
                                {files.map((file: any, index: number) => (
                                    <div className="flex mb-2" key={index}>
                                        <FileUpload
                                        file={files[index]}
                                        setFile={(file: any) => onSetFile(index, file)}
                                        />
                                        <div className="comm-btn__area">
                                            <Button
                                                className="btn-basic small gray ml-2"
                                                onClick={() => onDeleteFile(index)}
                                                text={t('common.button.delete')}
                                            />
                                        </div>
                                    </div>
                                ))}
                                <div className="comm-btn__area">
                                    <Button
                                        className="btn-basic pink-line"
                                        onClick={onAddFile}
                                        text={t('common.button.add')}
                                    />
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <th>{t('common.text.note')}</th>
                            <td colSpan={3}>
                                <textarea
                                    className="w-100"
                                    rows={2}
                                    value={note}
                                    onChange={(e) => setNote(e.target.value)}
                                    maxLength={300}
                                />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            {(expenseDetail?.data?.completeYn === 'N') &&
                <div className="comm-bx__between">
                    <div></div>
                    <div className="comm-btn__area">
                        {
                            /* 재무관리팀 1017 권한 처리 */
                            (auth.groupNo === FINANCIAL_TEAM_CODE || FINANCIAL_EDIT_PERMISSION.includes(auth.memberCode)) &&
                            <Button
                                onClick={()=>{setConfirmEditVisible(true)}}
                                className="btn-basic pink"
                                text={t('common.button.save')}
                                /*writeAuthYn={writeAuthYn}*/
                            />
                        }
                    </div>
                </div>
            }
            {confirmEditVisible && (
            <ConfirmModal
                visible={confirmEditVisible}
                setVisible={setConfirmEditVisible}
                onConfirm={onSaveButton}
                titleText={t('system.menu.title6')}
                messageText={t('payment.expense.msg12')}
                confirmText={t('common.button.save')}
                cancelText={t('common.button.cancel')}
            />
            )}
        </>
    )
}

export default ExpenseEditAmount;